import useBootstrapData from '@/hooks/useBootstrapData'
import useSeti from '@/hooks/useSeti'

import type { TypeAheadConfigEndpoint } from './types'

export function useHotelNeighbourhoodNesting({
  typeAheadEndpoint,
  enabled = false,
}: {
  typeAheadEndpoint: TypeAheadConfigEndpoint
  enabled?: boolean
}) {
  const { isMobile } = useBootstrapData()
  const isHotelsV2 = typeAheadEndpoint === 'hotelsV2'
  // Web-only rollout: neighbourhood nesting is gated to desktop (!isMobile) on this
  // branch. mweb is handled separately and is intentionally not enabled here.
  const shouldShowNesting = enabled && isHotelsV2 && !isMobile

  const setiVariant = useSeti({
    experimentCode: 'WEB_HTL_SEARCH_SCREEN_NBH_NESTING',
    shouldFireImpression: shouldShowNesting,
  })

  return shouldShowNesting && setiVariant === 'VARIANT'
}
